import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import FixedItineraryTable from 'components/fixedItinerary/FixedItineraryTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';

import FixedItineraryServices from 'services/FixedItineraryServices';
import FixedItineraryDrawer from 'components/drawer/FixedItineraryDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import { FiPlus } from 'react-icons/fi';
import Loader from 'components/form/Loader';
import sidebar from 'routes/sidebar';
const FixedItinerary = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;

	const { data, loading, error } = useAsync(
		FixedItineraryServices.getAllFixedItinerary
	);
	const [status, setStatus] = useState('');
	const { toggleDrawer, functionLoading } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(10);

	const {
		fixedItineraryRef,
		dataTable,
		handleSubmitFixedItinerary,
		currentPage,
		serviceData,
	} = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	// const isDataArray = Array.isArray(data?.data); // Check if data is an array
	// Use empty array if data is not an array
	const isAdmin = adminInfo?.id === 1;

	const hideView = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed basic rate' && perm.view === 1
		  );

	const hideDelete = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed basic rate' && perm.delete === 1
		  );

	const hideEdit = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed basic rate' && perm.edit === 1
		  );

	const hideAdd = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed basic rate' && perm.add === 1
		  );

	const hideExport = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'fixed basic rate' && perm.export === 1
		  );
	const updatedData = Array.isArray(data?.data)
		? data?.data.map((item) => {
				const { id, ...rest } = item;
				return rest;
		  })
		: [];
		// console.log("fixeditinerary", updatedData);
		

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	const finalData = data?.data?.map((item, itemIndex) => {
  const vehicleIds = item.vehicle_type_id || [];
  const vehicleNames = item.vehicle_type_names || {};

  const vehicleTypes = vehicleIds
    .map((vid) => vehicleNames[vid] || vid)
    .join("\n");

  return {
    "SI.No": itemIndex + 1,
    "Package Code": item.package_code, 
	"No Of Days/Nights": `${item.no_of_days || 0}/${item.no_of_nights || 0}`,
	"Route": item.route,  
   "Status": item.is_active == 0 ? "Inactive" : "Active", 
  };
});

	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<MainDrawer>
						<FixedItineraryDrawer id={serviceId} />
					</MainDrawer>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={fixedItineraryRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitFixedItinerary}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Fixed Itinerary
									</Button>
								)}

								{hideExport && (
									<ExportDataXlsx
										exportDataXlsx={finalData}
										fileNames="Fixed Itinerary Basic"
									/>
								)}
							</div>
						</CardBody>
					</Card>

					{functionLoading && <Loader message="Please wait..." />}
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<>
								<TableContainer>
									<div
										className="overflow-y-scroll"
										style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
									>
										<Table>
											<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
												<TableCell>Sl.No.</TableCell>
												<TableCell>Package Code</TableCell>
												<TableCell>Route</TableCell>
												<TableCell>No of Days/Nights </TableCell>
												<TableCell>Status</TableCell>
												<TableCell>Actions</TableCell>
											</TableHeader>
											<FixedItineraryTable
												fixedItinerary={dataTable}
												perpage={itemsPerPage}
												currentPage={currentPage}
												hideEdit={hideEdit}
												hideDelete={hideDelete}
											/>
										</Table>
									</div>
								</TableContainer>
							</>
						) : (
							<>
								{data.status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Fixed Itinerary." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default FixedItinerary;
